/**
 * @generated SignedSource<<1cb5f911a03ec7923c5d365af71edca7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FlavorPriceListParentComponentQuery$variables = {};
export type FlavorPriceListParentComponentQuery$data = {
  readonly getCustomerList: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly getLocationByCustomers: ReadonlyArray<{
    readonly customer: {
      readonly locations: ReadonlyArray<{
        readonly servicePlan: {
          readonly id: string;
          readonly indicater: string | null;
          readonly name: string;
        } | null;
      }> | null;
    } | null;
    readonly customerId: string;
    readonly id: string;
    readonly name: string;
  }>;
};
export type FlavorPriceListParentComponentQuery = {
  response: FlavorPriceListParentComponentQuery$data;
  variables: FlavorPriceListParentComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LocationObjectType",
    "kind": "LinkedField",
    "name": "getLocationByCustomers",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerId",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerObjectType",
        "kind": "LinkedField",
        "name": "customer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LocationObjectType",
            "kind": "LinkedField",
            "name": "locations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ServicePlanObjectType",
                "kind": "LinkedField",
                "name": "servicePlan",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "indicater",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomerObjectType",
    "kind": "LinkedField",
    "name": "getCustomerList",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FlavorPriceListParentComponentQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FlavorPriceListParentComponentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9fa4051f46d7fa3df9f14ecc78bb6929",
    "id": null,
    "metadata": {},
    "name": "FlavorPriceListParentComponentQuery",
    "operationKind": "query",
    "text": "query FlavorPriceListParentComponentQuery {\n  getLocationByCustomers {\n    id\n    customerId\n    name\n    customer {\n      locations {\n        servicePlan {\n          id\n          name\n          indicater\n        }\n      }\n    }\n  }\n  getCustomerList {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "da3ab5da1276a87f4ffbf1217c15707b";

export default node;
